import React from "react";
import ReactDOM from "react-dom/client";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./hooks/useAuth";
import reportWebVitals from "./reportWebVitals";
import { CssBaseline } from "@mui/material";
import { Slide, ToastContainer } from "react-toastify";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";
const outerTheme = createTheme({
  palette: {
    primary: {
      main: "#E4780E",
    },
    secondary: {
      main: "#000",
    },
  },
});
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider theme={outerTheme}>
    <Router>
      <AuthProvider>
        <App />
        <CssBaseline />
        <ToastContainer
          transition={Slide}
          position="top-right"
          marginTop="2rem"
        />
      </AuthProvider>
    </Router>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
